import styled from "styled-components";
import RegularText from "./RegularText";

export default styled(RegularText)`
  font-size: 12px;
  line-height: 16px;
`;
